<template>
  <transition name="slide-fade">
    <div id="create-menu">
      <div class="row" style="height: 100px">
        <input type="text" class="cool-input" placeholder="name*" @blur="name = normalizeName(name)"
               v-model="name"/>
      </div>
      <div class="row" style="height: 100px">
        <input type="password" v-model="password" class="cool-input" placeholder="password" />
      </div>
      <div class="row" style="height: 100px">
        <a href="#" class="action-button shadow animate green" @click="submit"><h1>Create</h1></a>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'create-menu',
  data () {
    return {
      name: '',
      password: ''
    }
  },
  methods: {
    normalizeName (value) {
      return value.toLowerCase().replace(/ /g, '')
    },
    submit () {
      if (this.name === '') {
        return
      }
      this.$emit('createPlaylist', {name: this.name, password: this.password})
    }
  }
}
</script>

<style type="scss" scoped>
  @import url('https://fonts.googleapis.com/css?family=Pacifico');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Rammetto+One');

  h1 {
    color: aliceblue;
  }

  .animate {
    transition: all 0.1s;
    -webkit-transition: all 0.1s;
  }

  .action-button{
    width: 100%;
    padding: 10px 40px;
    margin: 30px 30px 0 30px;
    float: left;
    border-radius: 10px;
    font-family: 'Pacifico', cursive;
    font-size: 25px;
    color: #1e1e1e;
    text-decoration: none;
  }

  .green {
    background-color: #82BF56;
    border-bottom: 5px solid #669644;
    text-shadow: 0px -2px #669644;
  }

  .action-button:active {
    transform: translate(0px, 5px);
    -webkit-transform: translate(0px, 5px);
    border-bottom: 1px solid;
    animation: bounce-in 1s;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .cool-input {
    color: aliceblue;
    font-family: 'Montserrat', sans-serif;
    font-size: 2em;
    text-align: center;
    margin: 0 auto;
    margin-bottom: .2em;
    margin-top: 25px;
    background-color: transparent;
    width: 90%;
    padding: 0;
    border: none;
    border-bottom: solid 5px #82BF56;
    &:focus {
      outline: none;
    }
  }
  input:focus{
    outline: none;
  }
  input:focus::-webkit-input-placeholder {
    opacity: 0;
  }
  .validateMe {
    border: 4px solid red;
    &:focus {
      border: 4px solid red;
    }
    animation-name: shake;
    animation-duration: .4s;
    animation-iteration-count: 1;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;
    animation-delay: 0s;
  }
  $sW: .5em;
  @keyframes shake {
    0% {
      transform: translateX(-$sW);
    }
    20% {
      transform: translateX($sW);
    }
    40% {
      transform: translateX(-$sW);
    }
    60% {
      transform: translateX($sW);
    }
    80% {
      transform: translateX(-$sW);
    }
    100% {
      transform: translateX(0);
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/CreateMenu.vue